import { termDictionary } from "./TermDictionary.slice";

export const termDictionaryActions = { ...termDictionary.actions };
